import { Role } from '.';

export interface IIdentity {
    name: string;
    roles: Role[];
    picture: string;
}

export class Identity implements IIdentity {
    name: string;
    roles: Role[];
    picture: string;

    constructor(name: string, roles: Role[], picture: string) {
        this.name = name;
        this.roles = roles;
        this.picture = picture;
    }
}